module.exports = __webpack_public_path__ + "static/media/blog3.44e1602b.png";